export const parseForcedFeatureFlags = (raw?: string): Set<string> =>
    new Set(
        (raw ?? '')
            .split(',')
            .map((flag) => flag.trim())
            .filter(Boolean)
    )

// Recette locale : sans clé GrowthBook aucun flag n'est lisible, d'où ce forçage par variable d'environnement
export const forcedFeatureFlags = parseForcedFeatureFlags(process.env.NEXT_PUBLIC_FORCED_FEATURE_FLAGS)

// Server components cannot read GrowthBook (its React context is client-only): the build-time forcing is their only signal
export function isFeatureFlagForced(featureId: string): boolean {
    return forcedFeatureFlags.has(featureId)
}
